export default __webpack_public_path__ + "static/media/cover.b2aef498.jpeg";